import { Routes } from '@angular/router';
import { PREFIXED_LANGS } from './core/data/languages.config';

// Every page is lazily loaded. Each product's area is its own set of routes and pages.
// Mounted once per language; a factory, because the router annotates the route objects it loads.
function contentRoutes(): Routes {
  return [
    {
      path: '',
      pathMatch: 'full',
      loadComponent: () => import('./pages/home/home').then((m) => m.Home),
    },
    {
      path: 'catalog',
      loadChildren: () => import('./pages/catalog/catalog.routes').then((m) => m.CATALOG_ROUTES),
    },
    {
      path: 'core',
      loadChildren: () => import('./pages/core/core.routes').then((m) => m.CORE_ROUTES),
    },
    {
      path: 'contact',
      loadComponent: () => import('./pages/contact/contact').then((m) => m.Contact),
    },
    {
      // Prerendered, and what the host serves with a 404 status for an address it has no file for.
      path: '404',
      loadComponent: () => import('./pages/not-found/not-found').then((m) => m.NotFound),
    },
    // Relative, so it stays inside its language branch: `/fr/iajhgfaze` goes to `/fr/404`.
    { path: '**', redirectTo: '404' },
  ];
}

export const routes: Routes = [
  ...PREFIXED_LANGS.map((lang) => ({ path: lang, children: contentRoutes() })),
  ...contentRoutes(),
];
